import styled from "styled-components";
export const DetialComponent = styled.div`
  padding: 32px 0;

  .side {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    overflow: hidden;

    .image {
      img {
        width: 100%;
      }
    }

    .content {
      padding: 8px;

      .labels {
        display: flex;
        margin-bottom: 16px;

        span {
          border-radius: 15px;
          border: solid 0 #050508;
          background-color: #dce5e5;
          font-size: 12px;
          font-weight: 500;
          padding: 6px 16px 2px 16px;
        }
      }

      .green-item {
        border-radius: 5px;
        background-color: #221C35;
        color: #fff;
        width: 100%;
        text-align: center;
        padding: 10px 6px 4px 6px;
        margin-bottom: 8px;
      }

      .grey-item {
        border-radius: 5px;
        background-color: #dce5e5;
        color: #010101;
        width: 100%;
        text-align: center;
        padding: 10px 6px 4px 6px;
        margin-bottom: 8px;
      }

      textarea {
        height: 180px;
        resize: none;
      }

      button {
        width: 100%;
      }
    }
  }

  .buttons {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    direction: rtl;
  }

  @media only screen and (max-width: 760px) {
    padding: 32px 0;
    .side {
      margin-bottom: 32px;

      .content {
        .green-item {
          padding: 10px 6px 6px 6px;
        }

        .grey-item {
          padding: 10px 6px 6px 6px;
        }
      }

      .desk-back {
        display: none;
      }
    }
  }
`;
